module.exports = __webpack_public_path__ + "static/media/NVD-logo.00b797bd.svg";